import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import  { useState } from "react";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

const IssueIndentActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess }) => {

    const [selectedButton, setSelectedButton] = useState(null);
    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);
        handlecallProcess(buttonName);
    };


    return (

        <Grid container display="flex-start" padding={0}>

            {/* Add Button */}
            {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} /> */}
            <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Edit Issue Indent">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton disabled onClick={() => handleButtonClick('selectAll')}  >
                            <ModeEditOutlineOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'selectAll' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Edit</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Delete Issue Indent">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton disabled onClick={() => handleButtonClick('ParentRolls')}>
                            <DeleteOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Delete</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Send Mail</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Send Mail">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton disabled onClick={() => handleButtonClick('Email')}>
                            <EmailOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Send Mail</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Send Mail</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="PDF/Print">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton disabled onClick={() => handleButtonClick('PDF')}>
                            <PictureAsPdfOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'PDF' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>PDF/Print</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>PDF/Print</span> */}
                    </div>
                </Tooltip>

            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="Ament Request">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton  disabled onClick={() => handleButtonClick('Ament')}>
                            <PictureAsPdfOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'PDF' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Request Amend Approval</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>PDF/Print</span> */}
                    </div>
                </Tooltip>

            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


        </Grid>



    )
};
export default IssueIndentActionMenu;